﻿'use strict';

var angular = require('angular');

require('es6-object-assign/auto'); // Copying objects is useful, but IE11/PhantomJS don't support ES6

//our modules
require('../components/authentication');
require('../components/authorization');
//require('../components/analytics');
require('../components/connections');
require('../components/session');
require('../components/admin');
require('../components/footer');
require('../components/header');
require('../components/uielements/dropdownmenu');
require('./constants.js');

//third party modules
require('angular-ui-bootstrap');
//require('angular-animate');
require('restangular');
require('lodash');
require('angular-cookies');
require('angular-ui-router');
require('AngularJS-Toaster');
require('angular-environment');
//require('angulartics-piwik');
//require('angular-smart-table');
require('angular-sanitize');
require('ng-tags-input');
require('ui-select');
//require('angulartics');
//require('angulartics-piwik');

//main app module for the application
angular.module('dpAdmin', [
    //'configure.configurationModule',
    'ui.router',
    'ngCookies',
    //'ngAnimate',
    'toaster',
    'ui.bootstrap',
    'environment',
    'ngSanitize',
    //'restangular',
    //'angulartics',
    //'angulartics.piwik',
    //'components.analyticsModule',
    'components.authenticationModule',
    'components.connectionsModule',
    'components.footerModule',
    'components.headerModule',
    'components.admin',
    'components.sessionModule',
    'components.authorizationModule',
    'components.uiElements.dropDownMenuModule'
    ])
    .config(['$stateProvider', '$httpProvider', '$urlRouterProvider', 'data_project_constants', 'envServiceProvider', 'RestangularProvider', function ($stateProvider, $httpProvider, $urlRouterProvider, data_project_constants, envServiceProvider) {

        //environmental configuration
        envServiceProvider.config({
            domains: {
                local:       ['dp-admin.exactbid.local', 'webpack-dp-admin.exactbid.local'],
                development: ['dev-dp-admin.exactbid.com'],
                staging:     ['stg-dp-admin.exactbid.com'],
                production:  ['dp-admin.exactbid.com']
            },
            vars: {
                local: {
                    api_authentication_endpoint: 'https://auth-dp-admin.exactbid.local/connect',
                    api_application_endpoint: 'https://api-dp-admin.exactbid.local/api/v1/',
                    reference_api_application_endpoint: 'https://api-reference.origin.exactbid.local/api/v1/',
                    award_api_application_endpoint: 'https://api.origin.exactbid.local/api/v1/',
                    auth_cookies_domain: '.exactbid.local',
                    analytics_domains: ['dp-admin.exactbid.local'],
                    analytics_url: '//piwik-dev.exactbid.com/',
                    //analytics_site_id: '11',
                    okta_issuer_url: 'https://lightbox-idp.oktapreview.com/oauth2/ausf3jaxas3VerhuE1d5', 
                    okta_redirect_url: 'https://webpack-dp-admin.exactbid.local:9089',
                    okta_client_id: '0oa2ikdm3IGwCxO5x1d6'
                },
                development: {
                    api_authentication_endpoint: 'https://auth-dev-dp-admin.exactbid.com/connect',
                    api_application_endpoint: 'https://api-dev-dp-admin.exactbid.com/api/v1/',
                    reference_api_application_endpoint: 'https://api-dev-reference.origin.exactbid.com/api/v1/',
                    award_api_application_endpoint: 'https://api-dev.origin.exactbid.com/api/v1/',
                    auth_cookies_domain: '.exactbid.com',
                    analytics_domains: ['dev-dp-admin.exactbid.com'],
                    analytics_url: '//piwik-dev.exactbid.com/',
                    //analytics_site_id: '12'
                    okta_issuer_url: 'https://lightbox-idp.oktapreview.com/oauth2/ausf3jaxas3VerhuE1d5', 
                    okta_redirect_url: 'https://dev-dp-admin.exactbid.com',
                    okta_client_id: '0oa2ikdm3IGwCxO5x1d6'
                },
                staging: {
                    api_authentication_endpoint: 'https://auth-stg-dp-admin.exactbid.com/connect',
                    api_application_endpoint: 'https://api-stg-dp-admin.exactbid.com/api/v1/',
                    award_api_application_endpoint: 'https://api-stg.origin.exactbid.com/api/v1/',
                    reference_api_application_endpoint: 'https://api-stg-reference.origin.exactbid.com/api/v1/',
                    auth_cookies_domain: '.exactbid.com',
                    analytics_domains: ['stg-dp-admin.exactbid.com'],
                    analytics_url: '//piwik-dev.exactbid.com/',
                    //analytics_site_id: '17'
                    okta_issuer_url: 'https://lightbox-idp.oktapreview.com/oauth2/ausf3jaxas3VerhuE1d5', 
                    okta_redirect_url: 'https://stg-dp-admin.exactbid.com',
                    okta_client_id: '0oa2ikdm3IGwCxO5x1d6'
                },
                production: {
                    api_authentication_endpoint: 'https://auth-dp-admin.exactbid.com/connect',
                    api_application_endpoint: 'https://api-dp-admin.exactbid.com/api/v1/',
                    reference_api_application_endpoint: 'https://api-reference.origin.exactbid.com/api/v1/',
                    award_api_application_endpoint: 'https://api.origin.exactbid.com/api/v1/',
                    auth_cookies_domain: '.exactbid.com',
                    analytics_domains: ['dp-admin.exactbid.com'],
                    analytics_url: '//stats.exactbid.com/',
                    //analytics_site_id: '6'
                    okta_issuer_url: 'https://lightbox-idp.okta.com/oauth2/ausz5xtoiY63iodFK4x6', 
                    okta_redirect_url: 'https://dp-admin.exactbid.com',
                    okta_client_id: '0oaz5yhx4AJomNMDQ4x6'
                }
            }
        });

        envServiceProvider.check();

        //default route for the application....may want to change this
        $urlRouterProvider.otherwise('/authentication/login');

        $stateProvider.state('home', {
            url: '',
            abstract: true,
            templateUrl: require('./layout-home.html')
        });

        $stateProvider.state('home.index', {
            url: '/index',
            authenticate: true,
            template: '<div>homeview</div>'
        });

        $httpProvider.interceptors.push(function ($location) {
            return {
                request: function (config) {
                    config.headers["RefererFullUrl"] = $location.absUrl();
                    return config;
                }
            };
        });
    }])
    .run(function ($rootScope, $state, authenticationFactory) {

        $rootScope.$state = $state;

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

            function loginRedirect() {
                $state.go('authentication.login');

                //prevent defaults stops events from doing anything so we can just redirect
                event.preventDefault();
            }

            if (!authenticationFactory.isBrowserCompatible(global)) {
                loginRedirect();
            }

            if (toState.name === "authentication.login") {
                return;
            }

            //these are set up in case the state does not have either a authenticate or a scope data member 
            var authenticateValue = toState.authenticate !== undefined ? toState.authenticate : false;

            //set up logic here for handling different roles and authentication
            if ((authenticateValue === true)) {
                authenticationFactory.oktaAuthClient.tokenManager.get('accessToken')
                    .then(function (token) {
                        if (token) {
                            console.log('Successfully retrieved Okta access token');
                        }
                        else {
                            loginRedirect();
                        }
                    })
                    .catch(function (error) {
                        console.error('Failed to retrieve Okta access token on state change: ' + error);
                        loginRedirect();
                    });
            }
        })
    });



//////////////////
// WEBPACK FOOTER
// ./source/angular/app/dpAdmin.js
// module id = 4
// module chunks = 0